// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"52baf27d","488":"d307afc0","977":"f71b7a63"}[chunkId] + ".chunk.js";
};